import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const MaingroupAttributeServiceConfig = {
  name: "MaingroupAttribute",
  annotations: []
} as ServiceConfig;